import type { ReactNode } from 'react';
import { useAuth } from '../auth/useAuth';
import { ForbiddenPage } from '../pages/ForbiddenPage';

interface RequirePermissionProps {
  permission: string;
  children: ReactNode;
}

export function RequirePermission({ permission, children }: RequirePermissionProps) {
  const { status, hasPermission } = useAuth();
  if (status === 'initializing') return null;
  if (!hasPermission(permission)) return <ForbiddenPage />;
  return <>{children}</>;
}
